import React from 'react';

interface IconContainerProps {
  children: React.ReactNode;
}

const IconContainer = ({ children }: IconContainerProps) => {
  return <div className='hidden md:flex p-1 lg:p-4 bg-black/3 rounded-full w-fit h-fit my-auto'>{children}</div>;
};

export default IconContainer;
